import styled from 'styled-components';

import { RadioGroup as RadioGroupBase } from '../../Insurance.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;
export const RadioGroup = styled(RadioGroupBase)`
  display: flex;
  gap: 8px;
  grid-column: 1/3;
  margin-bottom: 4px;
`;

export { Radio, Switcher } from '../../Insurance.styles';
